// import { useEffect } from 'react';
// import { useSearchParams } from 'react-router-dom';

// export default function IDVerificationComplete() {
//   const [searchParams] = useSearchParams();
//   const cleanerId = searchParams.get("cleanerId");

  
//   useEffect(() => {
//     // const deepLink = `freshsweeper://verification-complete${cleanerId ? `?cleanerId=${cleanerId}` : ''}`;

//     const deepLink = cleanerId 
//     ? `com.flavoursoft.freshsweeperv5://verification-complete?cleanerId=${cleanerId}`
//     : `com.flavoursoft.freshsweeperv5://verification-complete`;

//     window.location.href = deepLink;
//   }, [cleanerId]);

//   return <p>Redirecting to the app...</p>;
// }






import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { styled } from '@mui/material/styles';
import {
  Container,
  Box,
  Paper,
  Typography,
  Chip,
  Button,
  Divider,
  CircularProgress,
  Stack,
  Fade,
} from '@mui/material';

const IDVerificationComplete = () => {
  const [searchParams] = useSearchParams();
  const [redirectAttempted, setRedirectAttempted] = useState(false);
  const [showManualRedirect, setShowManualRedirect] = useState(false);
  const [countdown, setCountdown] = useState(5); // Countdown from 5 seconds
  const [isRedirecting, setIsRedirecting] = useState(false);

  const IconWrapper = styled(Box)(({ theme }) => ({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 80,
    height: 80,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #00c6ff, #0072ff)',
    color: '#fff',
    marginBottom: theme.spacing(2),
    boxShadow: '0 8px 24px rgba(0,114,255,0.3)',
  }));

  
  const cleanerId = searchParams.get("cleanerId");

  // Create the deep link URL
  const deepLink = cleanerId 
    ? `com.flavoursoft.freshsweeperv5://verification-complete?cleanerId=${cleanerId}`
    : `com.flavoursoft.freshsweeperv5://verification-complete`;

  // Countdown timer for automatic redirect
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0 && !isRedirecting) {
      // Auto redirect after countdown
      redirectToApp();
    }
  }, [countdown, isRedirecting]);

  // Show manual redirect button after initial delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowManualRedirect(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const redirectToApp = () => {
    if (isRedirecting) return;
    
    console.log('🔗 Redirecting to app:', deepLink);
    setIsRedirecting(true);
    setRedirectAttempted(true);
    
    // Try multiple methods for better compatibility
    const methods = [
      () => { window.location.href = deepLink; },
      () => { window.location.replace(deepLink); },
      () => { 
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = deepLink;
        document.body.appendChild(iframe);
        setTimeout(() => document.body.removeChild(iframe), 1000);
      }
    ];
    
    // Try each method
    methods.forEach(method => {
      try {
        method();
      } catch (e) {
        console.log('Redirect method failed:', e);
      }
    });

    // Fallback to web after delay if app isn't installed
    setTimeout(() => {
      if (document.visibilityState === 'visible') {
        console.log('📱 App not opened, showing web options');
        setIsRedirecting(false);
      }
    }, 2000);
  };

  // CSS styles matching your onboarding design
  const styles = {
    container: {
      padding: '40px 20px',
      textAlign: 'center',
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      maxWidth: '600px',
      margin: '0 auto',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f8fafc',
    },
    header: {
      marginBottom: '30px',
    },
    title: {
      fontSize: '32px',
      fontWeight: '700',
      color: '#1f2937',
      marginBottom: '16px',
    },
    subtitle: {
      fontSize: '18px',
      color: '#6b7280',
      marginBottom: '8px',
    },
    infoBox: {
      background: '#f0f9ff',
      padding: '20px',
      borderRadius: '12px',
      margin: '20px 0',
      border: '1px solid #bae6fd',
      width: '100%',
      maxWidth: '400px',
    },
    countdownBox: {
      background: '#fff',
      padding: '16px',
      borderRadius: '8px',
      margin: '20px 0',
      border: '1px solid #e5e7eb',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    },
    countdownText: {
      fontSize: '20px',
      fontWeight: '600',
      color: countdown > 2 ? '#10B981' : '#F59E0B',
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      margin: '30px 0',
      width: '100%',
      maxWidth: '300px',
    },
    primaryButton: {
      display: 'inline-block',
      padding: '16px 32px',
      backgroundColor: '#00BFFF',
      color: 'white',
      textDecoration: 'none',
      borderRadius: '10px',
      fontWeight: '600',
      fontSize: '18px',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.2s',
      boxShadow: '0 4px 12px rgba(0, 191, 255, 0.3)',
      width: '100%',
    },
    primaryButtonHover: {
      backgroundColor: '#0099CC',
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 16px rgba(0, 191, 255, 0.4)',
    },
    secondaryButton: {
      display: 'inline-block',
      padding: '14px 28px',
      backgroundColor: '#6c757d',
      color: 'white',
      textDecoration: 'none',
      borderRadius: '10px',
      fontWeight: '600',
      fontSize: '16px',
      border: 'none',
      cursor: 'pointer',
      transition: 'background-color 0.2s',
      width: '100%',
    },
    tertiaryButton: {
      display: 'inline-block',
      padding: '12px 24px',
      backgroundColor: 'transparent',
      color: '#00BFFF',
      textDecoration: 'none',
      borderRadius: '8px',
      fontWeight: '600',
      fontSize: '14px',
      border: '2px solid #00BFFF',
      cursor: 'pointer',
      transition: 'all 0.2s',
      width: '100%',
    },
    note: {
      fontSize: '14px',
      color: '#6b7280',
      marginTop: '8px',
    },
    successIcon: {
      fontSize: '64px',
      marginBottom: '20px',
      color: '#10B981',
    },
    loader: {
      display: 'inline-block',
      width: '50px',
      height: '50px',
      border: '4px solid #f3f3f3',
      borderTop: '4px solid #00BFFF',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
      marginBottom: '20px',
    },
    alternativeButtons: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      marginTop: '20px',
      width: '100%',
    },
    statusMessage: {
      padding: '12px',
      borderRadius: '8px',
      marginTop: '20px',
      fontSize: '14px',
      fontWeight: '500',
    },
    successMessage: {
      backgroundColor: '#d1fae5',
      color: '#065f46',
      border: '1px solid #a7f3d0',
    },
    errorMessage: {
      backgroundColor: '#fee2e2',
      color: '#dc2626',
      border: '1px solid #fecaca',
    },
  };

  // Add CSS animation for loader
  const addStyles = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  return (
    <div style={styles.container}>
      <style>{addStyles}</style>
      
      <div style={styles.header}>
        <div style={styles.successIcon}>
        <IconWrapper>
            <CheckCircleIcon sx={{ fontSize: 48 }} />
          </IconWrapper>
        </div>
        <h1 style={styles.title}>Identity Verification Complete!</h1>
        <p style={styles.subtitle}>
          Your identity has been successfully verified on FreshSweeper
        </p>
      </div>
      
      {cleanerId && (
        <div style={styles.infoBox}>
          <p style={{ margin: '0', color: '#1e40af', fontWeight: '500' }}>
            <strong>Cleaner ID:</strong> {cleanerId}
          </p>
        </div>
      )}

      {!showManualRedirect ? (
        <div>
          <div style={styles.loader}></div>
          <p>Processing your verification completion...</p>
        </div>
      ) : (
        <>
          {!redirectAttempted && (
            <div style={styles.countdownBox}>
              <p style={{ margin: '0 0 8px 0', color: '#6b7280' }}>
                Redirecting to app in:
              </p>
              <p style={styles.countdownText}>{countdown} seconds</p>
            </div>
          )}
          
          <div style={styles.buttonContainer}>
            <button 
              onClick={redirectToApp}
              style={{
                ...styles.primaryButton,
                ...(isRedirecting ? styles.primaryButtonHover : {}),
              }}
              disabled={isRedirecting}
              onMouseEnter={(e) => {
                if (!isRedirecting) {
                  e.target.style.backgroundColor = '#0099CC';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 16px rgba(0, 191, 255, 0.4)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isRedirecting) {
                  e.target.style.backgroundColor = '#00BFFF';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 12px rgba(0, 191, 255, 0.3)';
                }
              }}
            >
              {isRedirecting ? 'Opening App...' : 'Open FreshSweeper App'}
            </button>
            
            <p style={styles.note}>
              If the app doesn't open automatically, tap the button above.
            </p>
            
            <div style={styles.alternativeButtons}>
              <a 
                href={`/cleaner/dashboard?cleanerId=${cleanerId}`} 
                style={styles.secondaryButton}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#5a6268'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#6c757d'}
              >
                Continue on Web Dashboard
              </a>
              <a 
                href="/" 
                style={styles.tertiaryButton}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#00BFFF';
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#00BFFF';
                }}
              >
                Go to Homepage
              </a>
            </div>
          </div>
          
          {redirectAttempted && !isRedirecting && (
            <div style={{...styles.statusMessage, ...styles.successMessage}}>
              ✅ Verification complete! You can now access the app or web dashboard.
            </div>
          )}
          
          {isRedirecting && (
            <div style={{...styles.statusMessage, ...styles.successMessage}}>
              🔄 Attempting to open FreshSweeper app...
            </div>
          )}
        </>
      )}
      
      {/* Instructions for users */}
      <div style={{ 
        marginTop: '40px', 
        paddingTop: '20px', 
        borderTop: '1px solid #e5e7eb',
        fontSize: '12px',
        color: '#9ca3af',
        maxWidth: '400px',
      }}>
        <p style={{ margin: '0 0 8px 0' }}>
          <strong>Next Steps:</strong>
        </p>
        <ul style={{ 
          margin: '0', 
          paddingLeft: '20px', 
          textAlign: 'left',
          listStyleType: 'none',
        }}>
          <li style={{ marginBottom: '4px' }}>✅ Your identity is now verified</li>
          <li style={{ marginBottom: '4px' }}>📅 You can accept cleaning jobs immediately</li>
          <li style={{ marginBottom: '4px' }}>💰 Receive secure payments through Stripe</li>
          <li>⭐ Build your reputation with verified status</li>
        </ul>
      </div>
    </div>
  );
};

export default IDVerificationComplete;